import React from 'react';
import { LuLock, LuFileLock, LuLandmark } from 'react-icons/lu';
import { motion } from 'framer-motion';

export default function Solutions() {
  return (
    <section className="w-full max-w-[1240px] mx-auto px-4 md:px-8 pt-[112px] pb-[112px] flex flex-col items-center">
      <link href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;700&display=swap" rel="stylesheet" />
      
      <motion.h2 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="text-[72px] font-['Anton',sans-serif] font-normal text-center text-[#000] uppercase w-full mx-auto leading-[80px] mb-16 md:mb-24"
      >
        LIKE A NORMAL<br />BANK, BUT BETTER.
      </motion.h2>

      <div className="w-full grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-8 lg:gap-12 items-stretch">
        <motion.div 
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="w-full rounded-[24px] overflow-hidden relative bg-[#C0DFD6] pt-12 flex justify-center items-end min-h-[400px]"
        >
          <img 
            src="https://cdn.jiro.build/Random/image%207.png" 
            alt="Mobile banking app interface" 
            className="w-[85%] max-w-[340px] h-auto object-contain object-bottom -mb-[1px]"
          />
        </motion.div>

        <div className="w-full flex flex-col justify-center gap-4 overflow-hidden py-4">
          
          <motion.div 
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="p-6 md:p-8 rounded-[16px] border border-gray-200 flex flex-col sm:flex-row items-start sm:items-center gap-6 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.02)]"
          >
            <div className="w-16 h-16 rounded-[12px] bg-[#F1F3EE] flex items-center justify-center flex-shrink-0">
               <LuLock className="w-7 h-7 text-[#111]" strokeWidth={2} />
            </div>
            <p className="text-[#111] text-lg md:text-[21px] leading-[1.3] font-medium">
              Our dedicated fraud and security teams<br /> work to keep your money safe
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="p-6 md:p-8 rounded-[16px] border border-gray-200 flex flex-col sm:flex-row items-start sm:items-center gap-6 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.02)]"
          >
            <div className="w-16 h-16 rounded-[12px] bg-[#F1F3EE] flex items-center justify-center flex-shrink-0">
               <LuFileLock className="w-7 h-7 text-[#111]" strokeWidth={2} />
            </div>
            <p className="text-[#111] text-lg md:text-[21px] leading-[1.3] font-medium">
              We use advanced encryption and<br /> protect your personal data at all times
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="p-6 md:p-8 rounded-[16px] border border-gray-200 flex flex-col sm:flex-row items-start sm:items-center gap-6 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.02)]"
          >
            <div className="w-16 h-16 rounded-[12px] bg-[#F1F3EE] flex items-center justify-center flex-shrink-0">
               <LuLandmark className="w-7 h-7 text-[#111]" strokeWidth={2} />
            </div>
            <p className="text-[#111] text-lg md:text-[21px] leading-[1.3] font-medium">
              Your funds are held securely in<br /> regulated, top-tier global banks
            </p>
          </motion.div>

        </div>
      </div>
    </section>
  );
}